import { FiltersApi, FilterResponseDTO } from "@app/api/generated";
import { getAuthorizedApiConfig } from "@app/util/api-config";

export const getFilters = async (searchQuery: string, typeIds: string) => {
  try {
    if (!searchQuery) {
      return [];
    }

    const filterApi = new FiltersApi(await getAuthorizedApiConfig());
    const result: FilterResponseDTO = await filterApi.findAllBy({ searchQuery, take: 50, typeIds });

    return result.filters;
  } catch (error) {
    // TODO: Error logging
  }
};
